export default {
  namespaced: true,
  state: {
    records: [],
    total: 0,
    FilteredCount: 0,
    record: null,
    loading: false,
    listLoading: false,
    managerRecords: [],
    managerTotal: 0,
    managerFilteredCount: 0,
    managerListLoading: false,
    createManagerLoading: false
  },
  getters: {},
  mutations: {
    SET_STATE(state, { action, data }) {
      state[action] = data
    },
    SET_STATUS(state, { id, status, type }) {
      const index = state.records.findIndex((item) => item._id === id)
      if (index !== -1) {
        state.records[index][type] = status
      }
    }
  },
  actions: {
    async getHotelManagers({ commit }, params) {
      commit('SET_STATE', { action: 'managerListLoading', data: true })
      try {
        const response = await this.$http.get('admin/hotel/manager/list', { params })
        commit('SET_STATE', { action: 'managerListLoading', data: false })
        commit('SET_STATE', { action: 'managerRecords', data: response.data.data })
        // Combined users don't have pagination from backend yet in my implementation, but I'll set it if it does
        commit('SET_STATE', { action: 'managerTotal', data: response.data.data.length })
        commit('SET_STATE', { action: 'managerFilteredCount', data: response.data.data.length })
        return response.data
      } catch (error) {
        commit('SET_STATE', { action: 'managerListLoading', data: false })
        return Promise.reject(error)
      }
    },
    async inviteHotelManager({ commit }, data) {
      commit('SET_STATE', { action: 'createManagerLoading', data: true })
      try {
        const response = await this.$http.post('admin/hotel/manager/invite', data)
        commit('SET_STATE', { action: 'createManagerLoading', data: false })
        return response.data
      } catch (error) {
        commit('SET_STATE', { action: 'createManagerLoading', data: false })
        return Promise.reject(error)
      }
    },
    async revokeHotelManagerAccess({ commit }, { hotelId, userId }) {
      try {
        const response = await this.$http.put(`admin/hotel/manager/revoke/${hotelId}/${userId}`)
        return response.data
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async show({ commit }, id) {
      commit('SET_STATE', { action: 'loading', data: true })
      try {
        const response = await this.$http.get(`admin/hotel/${id}`)
        commit('SET_STATE', { action: 'loading', data: false })
        commit('SET_STATE', { action: 'record', data: response.data.data })
        return response.data
      } catch (error) {
        commit('SET_STATE', { action: 'loading', data: false })
        return Promise.reject(error)
      }
    }
  }
}
